/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Description from "App/model/description";
import {RenderElement} from "App/model/elements/element";
import {Factory} from "App/model/elements/factory";

export default
class ChunkLODNodeElement extends RenderElement {

    public static TypeName: string = "ChunkLODNode";

    constructor(aModelDescription: Description) {
        super(aModelDescription);
    }

    public static create(aModelDescription: Description, aUID: number) {
        let obj = new ChunkLODNodeElement(aModelDescription);
        obj._typeName = ChunkLODNodeElement.TypeName;
        obj._UID = aUID;
        return obj;
    }

    public getVisibility(): boolean {
        return this._sceneApiElementRef.getVisibility();
    }
}

Factory.register("ChunkLODNode", ChunkLODNodeElement);
